const SocialProofsArray = [

    {
        "text":"He primarily engaged with UNESCO’s Global Education Monitoring Regulation project. He was qery receptiqe to the feedback receiqed from his mentors and efficient in turning around the work.",
        "organization":"Center for Civil Society" 
    }, 

    {
        "text":"Works with great commitment and finishes the task at hand very efficiently. Really happy to have been working with him. ",
        "organization":"Project Freedom" 
    }

]

export default SocialProofsArray